import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-listado-comprobantes',
  templateUrl: './listado-comprobantes.component.html',
  styleUrls: ['./listado-comprobantes.component.css']
})
export class ListadoComprobantesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
